module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0020.jpg?v=37c13c5e";